<template>
  <div>
    <p>
      {{ $t('check') }}
    </p>
    <ol>
      <li>
        {{ $t('p1') }}
      </li>
      <li>
        {{ $t('p2') }}
      </li>
      <li>
        {{ $t('p3') }}
      </li>
    </ol>
    <br>
    <p>
      {{ $t('more') }} <a target="_blank" href="https://support.apple.com/guide/safari/ibrwe2159f50/">{{ $t('support') }}</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotAllowedMacOsSafari',
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
check: You have not given permission to access your camera or microphone.
p1: Choose the menu tab "Safari" → "Preferences" and click "Websites";
p2: Select first Camera and then Microphone and set "Allow" for huntica.ai;
p3: Close the settings and reload the page.
more: Learn more on the
support: Apple Support site
</i18n>

<i18n locale="ru" lang="yaml">
check: Вы не дали разрешение на доступ к камере или микрофону.
p1: Выберите меню «Safari» → «Настройки» и нажмите «Веб-сайты»;
p2: Выберите по очереди Камера и Микрофон и установите «Разрешить» для сайта huntica.ai;
p3: Закройте настройки и перезагрузите страницу.
more: Подробнее на сайте
support: поддержки Apple
</i18n>
